import { connect } from 'react-redux'
import ManagePlans from './ManagePlans'
import { returnUserIfUserExists } from '../../layouts/LoggedIn/actions'
import * as actions from './actions'

const mapStateToProps = (state, ownProps) => ({
  accountType: state.loginLayout.profile.accountType,
  stripeAccount: state.loginLayout.profile.stripeAccount,
  cancellationDate: state.loginLayout.profile.cancellationDate,
  nextInvoiceDate: state.loginLayout.profile.nextInvoiceDate,
  failedPaymentDate: state.loginLayout.profile.failedPaymentDate,
  failedPaymentCount: state.loginLayout.profile.failedPaymentCount,
  isUpdatingPlan: state.managePlans.isUpdatingPlan,
  planerror: state.managePlans.planerror,
  email: state.loginLayout.profile.email,
  paidUpgrade: state.managePlans.paidUpgrade,
  userId: state.loginLayout.profile.userid,
  view: state.loginLayout.view,
  userId: state.loginLayout.profile.userid,
  ...ownProps
})

const mapDispatchToProps = dispatch => ({
  changePlan: (token, plan) => dispatch(actions.changePlan(token, plan)),
  cancelPlan: (token) => dispatch(actions.cancelPlan(token)),
  createPlan: (token, payload) => dispatch(actions.createPlan(token, payload)),
  returnUserIfUserExists: token => dispatch(returnUserIfUserExists(token))
})

const ManagePlansContainer = connect(mapStateToProps, mapDispatchToProps)(
  ManagePlans
)

export default ManagePlansContainer



// WEBPACK FOOTER //
// src/routes/ManagePlans/ManagePlansContainer.js